import type { ApiResponse, IdLookupEntity, IdLookupResult } from '@/types'
import { adminApiClient } from '@/services/admin/baseService'

export const lookupService = {
  async lookupId(entity: IdLookupEntity, value: string): Promise<IdLookupResult> {
    const searchParams = new URLSearchParams({
      entity,
      value,
    })
    const response = await adminApiClient.get<ApiResponse<IdLookupResult>>(
      `/admin/id-lookup?${searchParams.toString()}`
    )

    if (!response.data?.success || !response.data.data) {
      throw new Error(response.data?.error || response.data?.message || 'Lookup failed')
    }

    return response.data.data
  },
}
